const CLAIM_NOTIFICATIONS_PRIORITY = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
} as const;

export default CLAIM_NOTIFICATIONS_PRIORITY;
